import { render, staticRenderFns } from "./StockTrend.vue?vue&type=template&id=f1e10642"
import script from "./StockTrend.vue?vue&type=script&lang=js"
export * from "./StockTrend.vue?vue&type=script&lang=js"
import style0 from "./StockTrend.vue?vue&type=style&index=0&id=f1e10642&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports